import FormField from './FormField';
import FormWrapper from './FormWrapper';
import AwsCredentialsSection from './AwsCredentialsSection';
import CredentialSecurityNotice from './CredentialSecurityNotice';
import ConnectionTestButton from './ConnectionTestButton';
import type { HealthLakeConfig } from '../../types';
import type { FieldConfig } from './types';
import { transformHealthLakeConfigForTest } from '../../utils/connectionConfigTransformers';
import { useConnectionTest } from '../../hooks/useConnectionTest';

const datastoreField: FieldConfig = {
    name: 'datastoreId',
    label: 'Datastore ID',
    type: 'text',
    required: true,
    placeholder: 'Enter datastore ID',
    extra: 'The unique identifier of your AWS HealthLake datastore',
};

const endpointField: FieldConfig = {
    name: 'endpoint',
    label: 'Custom Endpoint (Optional)',
    type: 'text',
    placeholder: 'https://healthlake.us-east-1.amazonaws.com',
    extra: 'Custom HealthLake endpoint URL if using VPC endpoint',
};

interface HealthLakeConfigFormProps {
    onConnectionTestSuccess?: () => void;
}

export default function HealthLakeConfigForm({ onConnectionTestSuccess }: HealthLakeConfigFormProps) {
    const { getConfig, handleTestConnection, isLoading } = useConnectionTest<HealthLakeConfig>(
        transformHealthLakeConfigForTest,
        config => Boolean(config?.datastoreId && config?.region && config?.accessKeyId && config?.secretAccessKey),
        onConnectionTestSuccess
    );

    return (
        <FormWrapper>
            <CredentialSecurityNotice />
            <FormField config={datastoreField} />
            <AwsCredentialsSection />
            <FormField config={endpointField} />
            {onConnectionTestSuccess && (
                <ConnectionTestButton
                    getConfig={getConfig}
                    testConnection={handleTestConnection}
                    isLoading={isLoading}
                />
            )}
        </FormWrapper>
    );
}
